import moment from 'moment';

// Global event bus
import Vue from 'vue';

export * from './requests';

export const EventBus = new Vue();

export const utils = { methods: { formatDate: (date, destinationFormat) => moment(date).format(destinationFormat) } };
